import { Fragment } from "react";
import "react-tooltip/dist/react-tooltip.css";
import ChartNav from "../../../common/ChartNav";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Medications from "../../clinical-services/medications/medications";
import Vaccines from "../../clinical-services/vaccines/vaccines";
import VaccineDashboard from "./VaccineDashboard";

const PatientVaccines = () => {
  const { patient } = useSelector((state) => state.patients);
  const [showMenu, setShowMenu] = useState(true);
  if (!patient) return null;

  return (
    <div className="relative flex flex-col flex-1 gap-4 bg-white pt-5">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Vaccines open={true}/>
          <div className="flex flex-1 min-h-0 overflow-visible">
            <VaccineDashboard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientVaccines;
